
const config = {
  "account": {
    "contact": "jason@reapcommerce.com",
    "id": "reap-commerce",
    "imageUrl": "https://storage.googleapis.com/avant-garde-cdn/axon/accounts/reap-commerce/assets/img/profile.png"
  },
  "assets": {
    "img": {
      "brand": {
        "backgrounds": {
          "profile": "https://storage.googleapis.com/avant-garde-cdn/axon/accounts/reap-commerce/assets/img/brand/backgrounds/profile.png"
        },
        "logo": "https://storage.googleapis.com/avant-garde-cdn/axon/accounts/reap-commerce/assets/img/brand/logo.png",
        "logo-white": "https://storage.googleapis.com/avant-garde-cdn/axon/accounts/reap-commerce/assets/img/brand/logo-white.png"
      }
    }
  },
  "footer": {
    "company": {
      "link": "https://reapcommerce.com",
      "name": "Reap Marketing, LP"
    }
  },
  "theme": {
    "palette": {
      "color-1": "#F4F6F5",
      "color-2": "#0D2311",
      "color-3": "#63A387",
      "color-4": "#009845",
      "color-5": "#FCFCFC"
    }
  }
}

export default config;
